import { BottomSection, CardListContainer, EmptyContinaer } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import RsvDetailInfoSideModal from "./rsv-detail-info-side-modal";
import { useEffect, useState } from "react";
import { getMyCompletedMeetingReservationList, TReservation } from "apis/meetings/meeting-reservation";
import { member } from "recoil/recoilState";
import { useRecoilValue } from "recoil";
import { MyBookingListSkeleton } from "uis/MyBooking";
const MyHistoryRsv = ({
  startDate = new Date(),
  endDate = new Date(),
  creatorOnly = false,
}: {
  startDate: Date;
  endDate: Date;
  creatorOnly: boolean;
}) => {
  const [openSideModal, setOpenSideModal] = useState<boolean>(false);
  const [selectedRsv, setSelectedRsv] = useState<TReservation>();
  const memberInfo = useRecoilValue(member);
  const [totalPage, setTotalPage] = useState<number>(1);
  const [page, setPage] = useState<number>(1);
  const [reservationList, setReservationList] = useState<TReservation[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getMyPastReservation = async (page: number) => {
    setLoading(true);
    const res = await getMyCompletedMeetingReservationList(page, startDate, endDate, creatorOnly);
    if (res.data) {
      setTotalPage(res.data.totalPageNumber);
      setPage(res.data.nowPageNumber);
      setReservationList(res.data.meetingReservationList);
    }
    setLoading(false);
  };

  useEffect(() => {
    getMyPastReservation(page);
  }, [startDate, endDate, creatorOnly]);

  useEffect(() => {
    if (!openSideModal) setSelectedRsv(undefined);
  }, [openSideModal]);

  return (
    <BottomSection>
      {loading && (
        <CardListContainer>
          <MyBookingListSkeleton />
          <MyBookingListSkeleton />
          <MyBookingListSkeleton />
          <MyBookingListSkeleton />
          <MyBookingListSkeleton />
        </CardListContainer>
      )}
      {!loading &&
        (reservationList.length === 0 ? (
          <EmptyContinaer>
            <UI.Icon name="calendar" size={24} color="var(--alias-color-label-alternative)" />
            <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
              지난 예약/참석이 없습니다.
            </UI.Typography>
          </EmptyContinaer>
        ) : (
          <CardListContainer>
            {reservationList.map((reservation, index) => (
              <UI.List.ListItem.PastReservation
                key={index}
                isSelected={selectedRsv === reservation}
                reservationStartDate={new Date(reservation.startTime)}
                reservationEndDate={new Date(reservation.endTime)}
                meetingRoomName={reservation.meetingRoom?.name}
                reservationTitle={reservation.title}
                creator={{
                  name: reservation.reservationCreator?.member?.nickname,
                  image: reservation.reservationCreator?.member?.image,
                  isVisitor: reservation.reservationCreator?.isVisitor,
                }}
                attendees={reservation.reservationAttendees?.map((attendee) => {
                  return {
                    name: attendee.isVisitor ? attendee.visitorEmail : attendee.member?.nickname,
                    image: attendee.member?.image,
                    isVisitor: attendee.isVisitor,
                  };
                })}
                myName={memberInfo?.nickname}
                isUsed={reservation.rsvStatus === "DONE"}
                onClick={() => {
                  setSelectedRsv(reservation);
                  setOpenSideModal(true);
                }}
              />
            ))}
          </CardListContainer>
        ))}
      {!loading && totalPage > 0 && (
        <UI.Pagination
          pageCount={totalPage}
          currentPage={page}
          onChange={(new_page) => {
            if (new_page !== page) {
              getMyPastReservation(new_page);
            }
          }}
        />
      )}
      <RsvDetailInfoSideModal
        open={openSideModal}
        setOpen={(value) => setOpenSideModal(value)}
        reservation={selectedRsv}
      />
    </BottomSection>
  );
};

export default MyHistoryRsv;
